module.exports = __webpack_public_path__ + "static/img/18.b8f55e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/18.jpg
// module id = JgCJ
// module chunks = 0